import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { CellContext } from '@tanstack/react-table';

export interface TokenListIssuerCellProps
  extends CellContext<GatewayTokenModel, GatewayTokenModel['issuer']> {}

export const TokenListIssuerCell = (
  props: TokenListIssuerCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text>{getValue() ?? '-'}</Text>;
};
